export const FORM_TEMPLATE_SYSTEM_KEY = {
  companyFatca: "company_fatca",
  employeeFatca: "employee_fatca",
} as const;

export type FormTemplateSystemKey =
  (typeof FORM_TEMPLATE_SYSTEM_KEY)[keyof typeof FORM_TEMPLATE_SYSTEM_KEY];
